import { render, staticRenderFns } from "./GooglePlayUpdateReviewStatus.vue?vue&type=template&id=bb7a6222&scoped=true"
import script from "./GooglePlayUpdateReviewStatus.vue?vue&type=script&lang=js"
export * from "./GooglePlayUpdateReviewStatus.vue?vue&type=script&lang=js"
import style0 from "./GooglePlayUpdateReviewStatus.vue?vue&type=style&index=0&id=bb7a6222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7a6222",
  null
  
)

export default component.exports